import { Link } from 'react-router-dom';
import { MARKETPLACE_URL } from '../../constants';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import Container from '../containers/container';
import HorizontalBar from '../horizontalBar';
import BrandIcon from '../icons/brand.icon';
import Icon from '../icons/icon';
import { HStack } from '../layouts/stack.layout';
import FavouriteChannels from '../lists/favourite-channels.list';
import DesktopNavigation from '../navigation/desktop.navigation';
import ExternalLinkWrapper from '../utility/external-link-wrapper';

export default function Header() {
  const { isDesktop } = useBreakpoints();

  return (
    <>
      <Link className="w-fit" to="/">
        <BrandIcon />
      </Link>

      <DesktopNavigation />

      <HorizontalBar spacing="lg" />

      <Container extensions="px-2.5">
        <ExternalLinkWrapper link={MARKETPLACE_URL}>
          <HStack extensions="items-center bg-secondary w-fit p-3 rounded-full hover:scale-105 ease-in transition-all">
            <Icon icon="marketplace" />
            {isDesktop && (
              <div className="font-text mx-3 text-sm uppercase font-medium">
                Marketplace
              </div>
            )}
          </HStack>
        </ExternalLinkWrapper>
      </Container>

      <HorizontalBar spacing="lg" />

      <FavouriteChannels />
    </>
  );
}
